import React, { useState, useEffect, useRef } from 'react';
 
import useTableFijo from "../useTableFijo";

import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import axios from 'axios';
import moment from 'moment';
import { ActualizarOrdenPago } from './modalActualizarOrdenPago';
import { ModalTrasladoFondos } from './modalSolicitudTraladoFondos';
import { ModalEnviarSolicitudTrasladoFondos } from './modalEnviarSolicitudTraslado';
import { IncluirAunmentoFondoAvance } from './modalAgregarAsignarFA';
import { formatMoneda } from '../../util/varios';

const TablaDetalleFondoAvance = (props) => {

    var op = require('../../../src/modulos/datos')
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const txtMonto1 = useRef();
    const txtMonto2 = useRef();
    const txtMonto3 = useRef();

    const headCells = [
        { id: '1', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Fecha Pago', textAlign: 'center' },
        { id: '2', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Tipo Documento', textAlign: 'center' },
        { id: '3', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'N° Documento', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto del Pago', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto del Compromiso', textAlign: 'center' },
        { id: '4', backgroundColor: 'rgba(5, 81, 130, 1)', color: '#ffffff', label: 'Monto de la Orden de Pago', textAlign: 'center' },

    ]

    const [values, setValues] = useState({
        idcuenta: "",
        auxiliar: "",
        descripcionaux: "",
        idcategoriaprogramatica: "",
        idpuc: "",
        puc: "",
        categoria: "",
        disponibilidad: 0.00,
        montoinicial: 0.00,
        tipopartida: "",

    });
    const [mostrar2, setMostrar2] = useState(false);
    const [mostrar, setMostrar] = useState(false);

    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [operacion, setOperacion] = useState(0);
    const [aprob, setAprob] = useState(null);
    const [aprobaciones, setAprobaciones] = useState();
    const [aprodetalle, setAprodetalle] = useState();
    const [norden, setNorden] = useState(true);
    const txtBuscador = useRef()
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })
    const [deshabilitado, setDeshabilitado] = useState(false);

    const {
        TblContainer,
        TblHead,
        recordsAfterPagingAndSorting,
        TblPagination
    } = useTableFijo(records, headCells, filterFn);







    const handleCloseSi = () => {

        setActivate(false);

    };



    useEffect(() => {
        if (props.detalles) {
            let array = [];

            for (let i = 0; i < props.detalles.length; i++) {
                array.push({
                    fechaorden: props.detalles[i].fechaorden,
                    monto: props.detalles[i].idordenpago !== null ? props.detalles[i].monto : 0,
                    idordenpago: props.detalles[i].idordenpago,
                    tipo: props.detalles[i].tipo,
                    montoorden: props.detalles[i].ordenpago !== null ? props.detalles[i].monto : 0,
                    montocompromiso: props.detalles[i].idcompromiso !== null ? props.detalles[i].monto : 0
                });
            }

            txtMonto1.current.value = formatMoneda(array.reduce((total, record) => total + parseFloat(record.monto), 0).toString().replace(',', '').replace('.', ','), ',', '.', 2)
            txtMonto2.current.value = formatMoneda(array.reduce((total, record) => total + parseFloat(record.momontoordennto), 0).toString().replace(',', '').replace('.', ','), ',', '.', 2)
            txtMonto3.current.value = formatMoneda(array.reduce((total, record) => total + parseFloat(record.montocompromiso), 0).toString().replace(',', '').replace('.', ','), ',', '.', 2)

           
            setRecords(array);
        }
    }, [props.detalles]);



    return (
        <div >
            <div className='col-md-12 mx-auto row px-0 '>
                <div className='col-md-12 px-0 mx-auto'>
                    <TblContainer container={{ height: 300, width: '100%', overflow: 'auto', padding: '2px' }}>
                        <TblHead />

                        <tbody>
                            {

                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={item + item.idordenpago} className="table-bordered" >
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{moment.utc(item.fechaorden).format('DD/MM/YYYY')}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.tipo}</td>
                                        <td style={{ fontSize: "10px", textAlign: "center" }}>{item.idordenpago}</td>
                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.monto.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.montoorden.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>
                                        <td style={{ fontSize: "10px", textAlign: "right" }}>{formatMoneda(item.montocompromiso.toString().replace(',', '').replace('.', ','), ',', '.', 2)}</td>


                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                </div>
                <div className='col-md-9'></div>
                <div className="input-group input-group-sm col-md-3 mb-1" >
                    <label className="input-group-text bg-transparent border-0 fw-bold" id="inputGroup-sizing-sm"> Total Aporte: </label>
                    <input type="text" className="form-control  bg-transparent border-0 text-right" ref={txtMonto1} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                </div>
                <div className='col-md-9'></div>
                <div className="input-group input-group-sm col-md-3 mb-1" >
                    <label className="input-group-text bg-transparent border-0 fw-bold" id="inputGroup-sizing-sm"> Total Comprometido: </label>
                    <input type="text" className="form-control  bg-transparent border-0 text-right" ref={txtMonto2} disabled={true} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                </div>
                <div className='col-md-9'></div>
                <div className="input-group input-group-sm col-md-3 mb-1" >
                    <label className="input-group-text bg-transparent border-0 fw-bold" id="inputGroup-sizing-sm"> Total Orden Pago: </label>
                    <input type="text" className="form-control  bg-transparent border-0 text-right" ref={txtMonto3} disabled={true} placeholder="0,00" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id="inputDireccion" />
                </div>

            </div>

            <IncluirAunmentoFondoAvance
                show={mostrar}
                onHideCancela={() => { setMostrar(false) }}
            />

            <Mensaje mensaje={mensaje}
                onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
            <MensajeSiNo mensaje={mensajesino}
                onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
            
<Dimmer active={activate} inverted>
       
      </Dimmer>
        </div>
    );
}
export default TablaDetalleFondoAvance;